export default function blockActiveDirectoryDirective() {
  return {
    template: require('./block-active-directory.html'),
    scope: {},
    controller: 'BlockActiveDirectoryController',
    controllerAs: 'bADVM',
    bindToController: true,
    replace: true,
  };
}
